import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LoginPageMessages } from '../messages';
import { SocialProvider } from '../../../types';

const Header = ({
  highlightedSocialProvider,
  showSocialLoginOnly,
}: {
  highlightedSocialProvider: SocialProvider | null;
  showSocialLoginOnly: boolean | null;
}) => {
  if (showSocialLoginOnly) {
    return (
      <FormattedMessage
        tagName="h5"
        {...LoginPageMessages.socialFormTitle}
        values={{
          socialProviderName: highlightedSocialProvider?.replace(/^./, str => str.toUpperCase()),
        }}
      />
    );
  }

  return <FormattedMessage tagName="h5" {...LoginPageMessages.headTitle} />;
};

export default Header;
